import { forwardRef, useMemo } from "react";
import { BaseCodeEditorProps } from "../codemirror-editor/BaseCodeEditor/BaseCodeEditor";
import { AutocompleteHandler } from "./NotebookCellEditor/types";
import { EditorView } from "@codemirror/view";
import { sheetOnlyHotKeys } from "../hotkeyConstants";
import { CodeMirrorApi } from "../codemirror-editor/CodeMirror";
import { CellIdPicker } from "../cell-id-picking/CellIdPicker";
import {
  EditorType,
  getSheetLanguageExtensions,
} from "../neptyne-sheet/SheetCodeEditor/sheetCodeEditorUtils";
import { mobileFontExtensions } from "../codemirror-editor/extensions/mobile-fonts";
import { isMobile } from "react-device-detect";
import { Box } from "@mui/material";

const CODE_PLACEHOLDER_TEXT = "Run code here to test it";

export interface ReplEditorProps extends BaseCodeEditorProps {
  getAutocomplete?: AutocompleteHandler;
  showPlaceholder: boolean;
}

export const ReplCellEditor = forwardRef<CodeMirrorApi, ReplEditorProps>(
  ({ getAutocomplete, showPlaceholder, readOnly, ...props }, ref) => {
    const value = props.value || "";
    const extensions = useMemo(
      () => [
        ...getSheetLanguageExtensions(
          value.toString(),
          getAutocomplete,
          EditorType.replPython
        ),
        EditorView.theme({
          "&.cm-editor": {
            backgroundColor: readOnly ? "#f5f5f5" : "#f3f9ff",
            border: "1px solid #e1e4e8",
          },
        }),
        ...(isMobile ? mobileFontExtensions : []),
      ],
      [getAutocomplete, readOnly, value]
    );

    return (
      <Box height="100%" overflow="auto" flexGrow={1}>
        <CellIdPicker
          ref={ref}
          extensions={extensions}
          mutedHotKeys={sheetOnlyHotKeys}
          testId="repl-editor"
          readOnly={readOnly}
          placeholder={showPlaceholder ? CODE_PLACEHOLDER_TEXT : undefined}
          {...props}
        />
      </Box>
    );
  }
);
